<div class="customer-stories">
  <div class="header">
    <app-navbar></app-navbar>
    <app-stories-header></app-stories-header>
  </div>
  <app-stories-grid></app-stories-grid>
  <app-footer></app-footer>
</div>
